module.exports = __webpack_public_path__ + "img/index4.b00d0d86.png";